<template>
  <div class="detail">
      <detail :mainTit="mainTit" :newInfo="newInfo">
        <template v-slot:right-related>
          <div class="row mt-5 summary" v-if="summary">
            <h5 style="color: #0092de; font-size: 1.2rem">
              {{ $t("lang.Summary") }}
            </h5>
            <div>
              {{ summary }}
            </div>
          </div>
          <detail-related
            :title="$t('lang.RelatedReading')"
            version="forum"
            :dataList="relatedList"
          ></detail-related>
        </template>
      </detail>
  </div>
</template>
<script>
import detail from "@/forumcomponents/detail.vue";
import detailRelated from "@/forumcomponents/detailRelated.vue";

export default {
  components: {
    detail,
    detailRelated,
  },
  data() {
    return {
      summary: "",
      video: "",
      mainTit: {
        topTxt: "AI伦理与治理系列 02期 · AI的公平性",
        lowTxt: "未来·局",
        date: "2021.05.23",
      },
      categoryId:'',
      newInfo: "",
      relatedList: [
        {
          title: "2020未来科学大奖举行云端颁奖典礼|科学之光 温暖世界",
          src: "http://www.futureprize.org/resource/data/uploads/13/2dfd9a8cc1aeb8737839d2d13a6ffe22.png",
          categoryId: "未来·局",
          date: "2012-5-26",
        },
        {
          title: "2020未来科学大奖举行云端颁奖",
          srcFileName:
            "http://www.futureprize.org/resource/data/uploads/13/2dfd9a8cc1aeb8737839d2d13a6ffe22.png",
          date: "2012-5-26",
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.id = to.query.id;
        this.categoryId = to.query.categoryId
        this.getNewInfo();
        this.getRelateNew();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  methods: {
    getNewInfo() {
      //活动详情
      this.$forumApi
        .newsInfo({
          id: this.id,
        })
        .then((res) => {
          console.log("getNewInfo----------", res);
          this.mainTit.topTxt = res.data.title;
          this.mainTit.lowTxt = res.data.categoryName;
          this.mainTit.date = res.data.createTime;
          this.newInfo = res.data.content;
        });
    },
    getRelateNew() {
      //相关活动
      this.$forumApi
        .relateNew({
          categoryId: this.categoryId,
          id: this.id,
        })
        .then((res) => {
          this.relatedList = res.data;
          console.log("getAelateActivityList----------", this.relatedList);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail::v-deep {
  .tabs {
    width: 100%;
    padding: 1rem 2rem 1rem 0rem;

    img {
      width: 100% !important;
    }
  }

  .summary {
    background-color: rgb(243, 242, 242);
    padding: 2rem;
    line-height: 1.8rem;
    color: #666666;
    flex: 1 1 0%;
  }

  .video {
    width: 95%;
    height: 30rem;
    margin-top: 3rem;
  }

  .topTxt {
    color: #333333;
    font-size: 1.6rem;
    font-weight: 530;
  }

  .lowTxt {
    font-size: 0.9rem;
    color: #666666;
    // display: flex;
    // justify-content: space-between;
    width: 15rem;
    margin: 0.5rem 0rem;
  }

  .nav-item {
    border: 1px solid lightgrey;
    padding: 0rem;
    width: 8.6rem;
    text-align: center;
    font-size: 0.2rem;

    a {
      border-radius: 0rem;
    }

    .tablelist {
      margin: 1rem 0rem 2rem 0rem;
    }
  }

  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #0092de;
  }
}
@media (max-width: 768px) {
  .detail::v-deep {
    .topTxt {
      font-size: 17px;
    }
    .right{
      padding:0px;
      width: 100%;
      background: white;
    }
  }
}
</style>